import { inject, Injectable } from '@angular/core';
import {
  CallidusCharterVersicherungspraemieCalcDto,
  ProductCallidusPipelineResultDto,
  PublicCallidusCharterApiService,
  PublicCallidusCharterContractCreateDto,
  VersicherungspraemieCalculationResultDto
} from '@backend/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CharterkautionStateService {
  private readonly publicCallidusCharterApiService = inject(PublicCallidusCharterApiService);

  /**
   * Charterkaution Prämienberechnung Ergebnis
   */
  calculateCharterPraemie(dto: CallidusCharterVersicherungspraemieCalcDto): Observable<VersicherungspraemieCalculationResultDto> {
    return this.publicCallidusCharterApiService
      .apiPublicCallidusCharterContractVersicherungspraemiePost(dto);
  }

  /**
   * Charterkaution Onboarding
   */
  submitCharterOnboarding(dto: PublicCallidusCharterContractCreateDto): Observable<ProductCallidusPipelineResultDto> {
    return this.publicCallidusCharterApiService
      .apiPublicCallidusCharterContractPost(dto);
  }
}
